import { useTranslation } from "react-i18next";
import { DocumentDetailsPage } from "components/common/DocumentDetailsPage";
import { findState } from "components/common/DocumentDetailsPage/utils";
import { initalizeStepsData } from "components/common/StepsContentGrid";
import StepsItemView from "components/common/StepsItemView";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RouteComponentProps, useHistory, useParams } from "react-router-dom";
import { getDocument, getDocumentsByType } from "services/users";
import { getDepositCrypto } from "services/users/deposit.service";

// const PageWrapper = styled.div`
//   width: 100%;
//   padding-top: 22px;
//   padding-left: 37px;
//   padding-right: 51px;
//   @media (max-width: 900px) {
//     padding: 30px 4px;
//   }
// `;

const config = [
    'Total',
    'Price',
    'Quantity',
    'Currency Type',
    'Type',
    'Approval Date',
    'Step'
];

type RouteParams = {
    id: string;
};

const ChangeInvestmentsDetails: React.FC<RouteComponentProps> = () => {
    const { t } = useTranslation();
    const { id } = useParams<RouteParams>();

    const history = useHistory();
    const { user, userCore } = useSelector(
        (state: any) => state.authReducer
    );

    const [data, setData] = useState<any>(null);
    const [documentData, setDocumentData] = useState<any>(null);
    const [bankDetailsData, setBankDetailsData] = useState<any>(null);

    const processDocument = (doc: any) => {
        //console.log(doc);
        setDocumentData(doc);
        const data: any = initalizeStepsData("SELL", ["", ""]);
        data[0].text = t("sell_coins_string").toUpperCase();
        data[1].text = t("buy_coins_string").toUpperCase();
        switch (doc.meta.state) {
            case "change_investment.crypto_sell_processed":
                data[0].status = "passed";
                break;
            case "change_investment.portfolio_processed":
                data[0].status = "passed";
                data[1].status = "passed";
                break;
            case "rejected":
                data[0].status = "rejected";
                break;
        }

        const loadBuyCoins = (coins: any[]) => {
            const passed = doc.meta.state == "change_investment.crypto_sell_processed" || doc.meta.state == "change_investment.portfolio_processed";
            let date = passed ? findState(doc, "change_investment.crypto_sell_processed")?.dt : null;
            const sellState=findState(doc, "crypto_sell");
            doc.meta.coins.forEach((coin: any) => {
                const sold=sellState?sellState.data.coins.find((c:any)=>c.coin==coin.coin):null;
                console.log(coin,sold);
                data.splice(1, 0, {
                    id: "SELL" + coin.coin,
                    step: null,
                    status: passed ? "passed" : "template",
                    approval_date: date || "-",
                    type: t("sell_string").toUpperCase(),
                    text: coin.coin + " ⇄ USD",
                    currency_type: t("crypto_string"),
                    currency: coin.coin,
                    quantity: sold ? sold.usdtVolume : "-",
                    quantityDecimals: 8,
                    price: sold ? sold.price : "-",
                    priceDecimals: 8,
                    total: coin.cryptoVolume,
                    totalDecimals: 8,
                });
            });
            date = passed ? findState(doc, "change_investment.portfolio_processed")?.dt : null;
            const buyState=findState(doc, "crypto_buy");
            if(doc?.meta?.imp_id) {
                buyState.data.coins.forEach((coin: any) => {
                    const bought=buyState?buyState.data.coins.find((c:any)=>c.coin==coin.coin):null;
                    data.push({
                        id: "BUY" + coin.coin,
                        step: null,
                        status: passed ? "passed" : "template",
                        approval_date: date || "-",
                        type: t("buy_string").toUpperCase(),
                        text: "USD ⇄ " + coin.coin,
                        currency_type: t("crypto_string"),
                        currency: "USD",
                        quantity: bought?bought.cryptoVolume:"-",
                        quantityDecimals: 8,
                        price: bought?bought.price:"-",
                        priceDecimals: 8,
                        total: coin.usdtVolume,
                        totalDecimals: 8,
                        priceModifier: 1,
                    });
                });
            } else {
                coins.forEach((coin: any) => {
                    const bought=buyState?buyState.data.coins.find((c:any)=>c.coin==coin.coin):null;
                    data.push({
                        id: "BUY" + coin.coin,
                        step: null,
                        status: passed ? "passed" : "template",
                        approval_date: date || "-",
                        type: t("buy_string").toUpperCase(),
                        text: "USD ⇄ " + coin.coin,
                        currency_type: t("crypto_string"),
                        currency: "USD",
                        quantity: bought?bought.cryptoVolume:"-",
                        quantityDecimals: 8,
                        price: bought?bought.price:"-",
                        priceDecimals: 8,
                        total: coin.usdtVolume,
                        totalDecimals: 8,
                        priceModifier: 1,
                    });
                });
            }
            setData(data);
        };

        if (doc.meta.buy_coins) {
            loadBuyCoins(doc.meta.buy_coins);
        }
        else {
            getDepositCrypto(doc.id).then(res => {
                if (res?.data?.coins) {
                    loadBuyCoins(res?.data?.coins);
                }
            });
        }

    };

    const reloadDocuments = () => {
        getDocument(id).then(doc => {
            if (doc) {
                processDocument(doc);
            }
        });
    };

    useEffect(() => {
        if (!user || !userCore) {
            return history.push('/');
        }
        reloadDocuments();
    }, []);

    useEffect(() => {
        if (!user) {
            return history.push('/');
        }
    }, [user, userCore]);

    return (
        <DocumentDetailsPage
            title={t("change_investment_details_string")}
            columns={config}
            documentData={documentData}
            bankDetails={bankDetailsData}
            stepsData={data}
/*             BAMCId={BAMCId}
            BAMCStatus={BAMCStatus}
            BAMCStatusClass={BAMCStatusClass}
 */            processing={false}
            itemComponent={StepsItemView}
/*             onViewBAMC={() => {
                console.log("VIEW DOCUMENT", BAMCId, bankDetailsData?.meta?.bank_details);
                //@ts-ignore
                setViewBAMC(true);
                // setViewBAMC(true);
                //@ts-ignore
                document.getElementById("view-document-btn").click();
            }}
 */        >
            {/*             {BAMCId ? <ViewDocumentModal closeModal={() => { setViewBAMC(false); }} openViewModal={viewBAMC} documentId={BAMCId} documentMeta={BAMCMeta} /> : null}
 */}
            {/*             <ViewDocumentModal documentId={BAMCId} openViewModal={viewBAMC} closeModal={() => {
                setViewBAMC(false);
                //@ts-ignore
                document.getElementById("view-document-btn-close").click();
            }} />
 */}
        </DocumentDetailsPage>
    );
}

export default ChangeInvestmentsDetails;
